import React from 'react';
import { Button } from '../../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Ban } from 'lucide-react';

const BlocksTab = ({ blocks, unblockTalent }) => {
  return (
    <Card className="bg-white border-gray-200 shadow-sm">
      <CardHeader>
        <CardTitle className="text-xl text-gray-900 flex items-center gap-2">
          <Ban className="w-5 h-5 text-gray-400" />
          Blocked Talent
        </CardTitle>
      </CardHeader>
      <CardContent>
        {blocks.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            No blocked talent. Blocked talent won't appear in your searches.
          </div>
        ) : (
          <div className="space-y-3">
            {blocks.map((block) => (
              <div 
                key={block.id} 
                className="flex items-center justify-between p-4 bg-gray-50 rounded-lg"
              >
                <div className="flex items-center gap-4">
                  {block.profile_photo_url ? (
                    <img 
                      src={block.profile_photo_url} 
                      alt={block.first_name}
                      className="w-12 h-12 rounded-full object-cover grayscale"
                    />
                  ) : (
                    <div className="w-12 h-12 rounded-full bg-gray-300 flex items-center justify-center">
                      <span className="text-gray-500 font-medium">
                        {block.first_name?.[0]}{block.last_name?.[0]}
                      </span>
                    </div>
                  )}
                  <div>
                    <h3 className="font-medium text-gray-900">{block.first_name} {block.last_name}</h3>
                    <p className="text-sm text-gray-500">{block.city}, {block.state}</p>
                    {block.reason && (
                      <p className="text-xs text-gray-400 mt-1">Reason: {block.reason}</p>
                    )}
                  </div>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => unblockTalent(block.talent_id)}
                  className="text-cyan-600 border-cyan-300 hover:bg-cyan-50"
                >
                  Unblock
                </Button>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default BlocksTab;
